<div class="footer"
     fxLayoutAlign="center center">
     
  <div class="footer__label">SINDAUTO &copy; {{ currentYear }}</div>

  <img class="footer__logo"
       src="../../../../assets/images/png/logo.png"
       fxHide.xs>

</div>
